export const SESSION_EVENT = {
  userProfileUpdate: 'adn.event:user-profile-update'
};
